import { render } from "./MySpinner.vue?vue&type=template&id=77a3705c&scoped=true"
const script = {}

import "./MySpinner.vue?vue&type=style&index=0&id=77a3705c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a3705c"]])

export default __exports__